export default __webpack_public_path__ + "static/media/avatar.cf8b3a35.png";